import { CoreApp } from '@grafana/data';
import { addEnterpriseProviders } from 'app/AppWrapper';

import { QueryLibraryContextProvider } from './QueryLibraryContextProvider';

export function initQueryLibrary() {
  addEnterpriseProviders(QueryLibraryContextProvider);
}

export function getQueryLibraryRenderContext(app?: string): string {
  switch (app) {
    case CoreApp.Explore:
      return CoreApp.Explore;
    case CoreApp.PanelEditor:
      return CoreApp.PanelEditor;
    default:
      return 'unknown';
  }
}

/**
 * This is used to determine the app that the query library is rendered in.
 * It's needed to render the QueryEditor component.
 * Otherwise, it could break due to unsupported query options
 * Defaults to Explore if no context is provided.
 */
export function parseQueryLibraryRenderContext(context?: string): CoreApp {
  switch (context) {
    case CoreApp.PanelEditor:
      return CoreApp.PanelEditor;
    case CoreApp.Explore:
    case 'rich-history':
    default:
      return CoreApp.Explore;
  }
}
